import React, { memo, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import TemplateList from './enrich-templates-list-step';

import { GetTemplateOptionListProps, TemplateListProps } from '../types';
import {
  deleteAiColumnTemplateRequest,
  getTemplateOptionList,
} from '../../../../../extra-actions';
import { RootState } from '../../../../../../../store/root-reducer';

const TemplateListContainer = memo((props: TemplateListProps) => {
  const dispatch = useDispatch();

  const getTemplateOptionListRequest = useCallback(
    (payload: GetTemplateOptionListProps) => {
      dispatch(getTemplateOptionList(payload));
    },
    [dispatch],
  );

  const handleDeleteAiColumnTemplate = useCallback(
    (id: number) => {
      dispatch(deleteAiColumnTemplateRequest(id));
    },
    [dispatch],
  );

  const { hasMore } = useSelector(
    (state: RootState) => state?.prospect?.aiTemplatesPagination,
  );

  const isAiColumnTemplateListCachedFromFilter = useSelector(
    (state: RootState) => state?.prospect?.isAiColumnTemplateListCachedFromFilter,
  );
  const templateLists = useSelector(
    (state: RootState) => state?.prospect?.aiTemplates,
  );
  const getTemplateRequestStatus = useSelector(
    (state: RootState) => state?.prospect?.getAiModelTemplates.status,
  );

  const deleteTemplateStatus = useSelector(
    (state: RootState) =>
      state?.prospect?.deleteAiColumnTemplateRequest?.status,
  );

  return (
    <TemplateList
      {...props}
      getTemplateOptionListRequest={getTemplateOptionListRequest}
      handleDeleteAiColumnTemplate={handleDeleteAiColumnTemplate}
      hasMore={hasMore}
      templateLists={templateLists}
      getTemplateRequestStatus={getTemplateRequestStatus}
      deleteTemplateStatus={deleteTemplateStatus}
      isAiColumnTemplateListCachedFromFilter={isAiColumnTemplateListCachedFromFilter}
    />
  );
});

export default TemplateListContainer;
